import { render, staticRenderFns } from "./ReceiptCart.vue?vue&type=template&id=34132928&scoped=true&"
import script from "./ReceiptCart.vue?vue&type=script&lang=ts&"
export * from "./ReceiptCart.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptCart.vue?vue&type=style&index=0&id=34132928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34132928",
  null
  
)

export default component.exports